/**
 * @author Antoine Laviron
 * @date 2024-08-27
 *
 * @description
 * This is the root component of the application. It is responsible for setting up
 * the client-side routing and defining the overall structure of the application's
 * pages. It uses `react-router-dom` to map URL paths to specific page components.
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// --- Component Imports ---
import Layout from './components/Layout'; 

// --- Page Imports ---
import Login from './pages/Login';
import Callback from './pages/Callback';
// import DashboardList from './pages/DashboardList';
import SalesCloud from './pages/SalesCloud';
import Playground from './pages/Playground'; 
import AuthFlow from './pages/AuthFlow';



// --- Style Imports ---
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/playground" element={<Playground />} />
          <Route element={<Layout />}>
            {/* <Route path="/dashboard" element={<DashboardList />} /> */}
            <Route path="/salescloud" element={<SalesCloud />} />
            <Route path="/auth-flow" element={<AuthFlow/>} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;